<po-page-edit
  p-title="Etiqueta Materia Prima Fornecedor 1"
>
  <po-container>
    <form #formEtiqueta="ngForm">
      <po-lookup class="po-sm-12 po-md-12 po-lg-12"
        p-label="Fornecedor"
        name="CA2CODLOJA"
        [(ngModel)]="etiqueta.CA2CODLOJA"
        p-field-label="CA2NREDUZ"
        p-field-value="CA2CODLOJA"
        [p-columns]="fornecedorColumnsFilters"
        [p-field-format]="fornecedorLookupService.getFieldFormater"
        [p-filter-service]="fornecedorLookupService"
        [p-advanced-filters]="fornecedorLookupService.getAdvancedFilter()"
        [p-literals]="{ modalTitle: 'Fornecedor' }"
        [p-filter-params]="{CA2MSBLQL: '2'}"
        p-required="true"
        p-show-required="true"
      ></po-lookup>
      <po-lookup class="po-sm-12 po-md-12 po-lg-12"
        p-label="Produto"
        name="CB1COD"
        [(ngModel)]="etiqueta.CB1COD"
        p-field-value="CB1COD"
        p-field-label="CB1DESC"
        [p-columns]="produtoColumnsFilters"
        [p-field-format]="produtoLookupService.getFieldFormater"
        [p-filter-service]="produtoLookupService"
        [p-advanced-filters]="produtoLookupService.getAdvancedFilter()"
        [p-literals]="{ modalTitle: 'Produto' }"
        [p-filter-params]="{CB1MSBLQL: '2', CB1TIPO: 'MP;PP;PI'}"
        p-required="true"
        p-show-required="true"
      ></po-lookup>
      <po-datepicker class="po-sm-12 po-md-3 po-lg-3"
        name="DRECEBIMENTO"
        p-label="Recebimento"
        [(ngModel)]="etiqueta.DRECEBIMENTO"
        p-format="dd/mm/yyyy"
        [p-iso-format]="formatExtended"
        p-required="true"
        p-show-required="true"
      ></po-datepicker>
      <po-decimal class="po-sm-12 po-md-4 po-lg-3"
        name="NQUANTIDADE"
        p-label="Quantidade"
        [(ngModel)]="etiqueta.NQUANTIDADE"
        p-decimals-length="3"
        p-min="0.001"
        p-required="true"
        p-show-required="true"
      ></po-decimal>
      <po-input
        class="po-sm-12 po-md-4 po-lg-3"
        name="CLOTEFORNECEDOR"
        [(ngModel)]="etiqueta.CLOTEFORNECEDOR"
        p-label="Lote do Fornecedor"
        p-required="true"
        p-show-required="true"
      ></po-input>
    </form>
    <po-button class="po-sm-12 po-md-8 po-lg-9"
      p-label="Gera Etiqueta"
      p-icon="po-icon-ok"
      (p-click)="gerarEtiqueta()"
    ></po-button>
    <po-button class="po-sm-12 po-md-4 po-lg-3"
      p-label="Limpar a Tela"
      p-icon="po-icon-delete"
      (p-click)="limparTela()"
      p-danger="true"
    ></po-button>
  </po-container>
</po-page-edit>
